import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { setClickCount, setCommonConfig, setCurrentStep } from '../../redux/actions';
import { TbBulb } from 'react-icons/tb';
import { MdKeyboardArrowRight } from 'react-icons/md';
import { makeAjax, respStatus, showMessage, url } from '../../helpers/global_helper';

function CoachMarkPopup() {
    const dispatch = useDispatch()
    const currentStep = useSelector((state) => state.paginationData.currentStep)
    const clickStep = useSelector((state) => state.paginationData.clickStep)
    const isSettingCoachMark = useSelector((state) => state.paginationData.isSettingCoachMark)
    const device = useSelector((state) => state.CommonConfig.device_type);
    const marketCloseStatus = useSelector((state) => state.CommonConfig.marketCloseStatus);
    const allowed_games = useSelector((state) => state.CommonConfig.allowed_games);
    const gameId = useSelector((state) => state.CommonConfig.gameId);
    const depositUrl = sessionStorage.getItem("depositUrl");

    const coachDataEngLang = {
        "0": {
            "step": "1",
            "header": "Market",
            "description": "Select your betting market.",
            "closeMarketRowOne": "The betting panel is currently closed.",
            "closeMarketRowTwo": "Please select another Togel market"
        },
        "1": {
            "step": "2",
            "header": "Switching to Sub-Games Tab",
            "description": "Switch between tabs to choose your preferred bet type.",
        },
        "2": {
            "step": "3",
            "header": "Guess Numbers",
            "description": "Enter your guessed numbers here.",
        },
        "3": {
            "step": "4",
            "header": "Auto Bet",
            "description": "Input a number, and the system auto-fills the bet quantity.",
        },
        "4": {
            "step": "5",
            "header": "BB (Bolak Balik)",
            "description": "Toggle BB to create all number combinations.",
        },
        "5": {
            "step": "6",
            "header": "Discount & Pay",
            "description": "View discount and pay amount for each row.",
        },
        "6": {
            "step": "7",
            "header": "Reset bets",
            "description": "Click 'Reset' to clear all bets.",
        },
        "7": {
            "step": "8",
            "header": "Submit Bet",
            "description": "Press 'Submit' to place your bet.",
        },
        "8": {
            "step": "9",
            "header": "Light mode and Dark mode",
            "description": "Switch between dark and light modes for a comfortable viewing experience.",
            "headerTwo": "Choose Language",
            "descriptionTwo": "You can choose indonesia or english language."
        },
        "9": {
            "step": "10",
            "header": "Result Analysis",
            "description": "Use result analysis to review past results and identify patterns that can help inform your betting strategy.",
        },
        "10": {
            "step": "11",
            "header": "Info",
            "description": "View all your bet transactions and invoices in one place.",
        },
        "11": {
            "step": "12",
            "header": "Versi WAP",
            "description": "Place a bet in simplified format.",
        },
        "12": {
            "step": "13",
            "header": "Result Information",
            "description": "Check the past result history of the selected market.",
        },
        "13": {
            "step": "14",
            "header": "Top Up Balance",
            "description": "Click this button to make a deposit.",
        },
        "skipAll": "SKIP ALL",
        "next": "NEXT",
        "done": "DONE",
        "close": "CLOSE"
    }

    const coachDataIndoLang = {
        "0": {
            "step": "1",
            "header": "Pasaran",
            "description": "Pilih pasaran.",
            "closeMarketRowOne": "Panel bettingan sedang di tutup.",
            "closeMarketRowTwo": "Silahkan pilih pasaran Togel yang lain"
        },
        "1": {
            "step": "2",
            "header": "Memilih Jenis Bettingan",
            "description": "Pindah tab untuk pilih jenis bettingan yang anda inginkan.",
        },
        "2": {
            "step": "3",
            "header": "Tebak Nomor",
            "description": "Masukkan nomor tebakan anda.",
        },
        "3": {
            "step": "4",
            "header": "Auto Bet",
            "description": "Masukan Nominal bet, dan sistem akan otomatis mengisi nominal bet.",
        },
        "4": {
            "step": "5",
            "header": "BB (Bolak Balik)",
            "description": "Centang BB untuk bet semua kombinasi nomor.",
        },
        "5": {
            "step": "6",
            "header": "Diskon & Bayar",
            "description": "Menampilkan nominal Diskon dan Bayar untuk setiap line/baris.",
        },
        "6": {
            "step": "7",
            "header": "Reset",
            "description": "Klik RESET untuk reset/hapus semua bettingan anda.",
        },
        "7": {
            "step": "8",
            "header": "Submit Bet",
            "description": "Klik 'KIRIM' untuk proses taruhan anda.",
        },
        "8": {
            "step": "9",
            "header": "Mode Terang dan Gelap",
            "description": "Pilih antara mode terang dan gelap yang sesuai dengan preferensi anda.",
            "headerTwo": "Pilihan Bahasa",
            "descriptionTwo": "Anda dapat memilih bahasa indonesia atau bahasa english."
        },
        "9": {
            "step": "10",
            "header": "Hasil Result",
            "description": "Gunakan hasil result untuk review result sebelumnya dan identifikasi pola yang bisa membantu strategi betting anda.",
        },
        "10": {
            "step": "11",
            "header": "Info",
            "description": "Lihat semua transaksi dan invoice bettingan anda pada 1 tempat.",
        },
        "11": {
            "step": "12",
            "header": "Versi WAP",
            "description": "Dapat melakukan bettingan dengan format yang simple.",
        },
        "12": {
            "step": "13",
            "header": "Informasi Result",
            "description": "Pencarian hasil akhir untuk pasaran yang di pilih.",
        },
        "13": {
            "step": "14",
            "header": "Tambah Saldo",
            "description": "Klik tombol ini untuk melakukan deposit.",
        },
        "skipAll": "LEWATI",
        "next": "BERIKUT",
        "done": "SELESAI",
        "close": "TUTUP"
    };
    const language = localStorage.getItem('I18N_LANGUAGE') || 'en';
    const selectedData = language === 'id' ? coachDataIndoLang : coachDataEngLang;

    // const handleNext = () => {
    //     if (device === 'Mobile' && currentStep == 4) {
            
    //         dispatch(setCurrentStep(currentStep + 2)); // Reset Redux state
    //     } else {
            
    //         dispatch(setCurrentStep(currentStep + 1)); // Reset Redux state
    //     }
    //     if (device === 'Mobile' && currentStep == 10) {
            
    //         dispatch(setCurrentStep(-1)); // Reset Redux state

    //     }
        
    //     dispatch(setClickCount(clickStep + 1))

    // };

const handleNext = () => {
  if (device === 'Mobile') {
    if (currentStep === 4) {
      dispatch(setCurrentStep(currentStep + 2)); // Skip from 4 to 6 on mobile
    } else if (currentStep === 10) {
      // If depositUrl exists, go to step 11 (deposit CoachMark)
      if (depositUrl) {
        dispatch(setCurrentStep(13));
      } else {
        dispatch(setCurrentStep(-1)); // End tour
      }
    } else {
      dispatch(setCurrentStep(currentStep + 1));
    }
  } else {
    // Desktop logic
    dispatch(setCurrentStep(currentStep + 1));
  }
  dispatch(setClickCount(clickStep + 1));
};

    const handleCloseMarket = () => {
        dispatch(setCurrentStep(-1));
    };

    // let valueDone = device == 'Mobile' ? 10 : 12;
    // let valueDone = device === 'Mobile' ? 10 : (depositUrl ? 14 : 12);
// const valueDone = device === 'Mobile'
//   ? 10
//   : depositUrl
//     ? 13
//     : 12;

const valueDone = device === 'Mobile'
  ? (depositUrl ? 11 : 10)
  : (depositUrl ? 13 : 12);
    const handleDone = () => {
        // dispatch(setCurrentStep(-1)); // Close the popup on "Done"
        if (isSettingCoachMark === false) {
            // Call API to update CoachMark status
            makeAjax(url.PLAYER_API.updateCoachMarkStatus, {}, url.PLAYER_MS_EXT)
                .then((response) => {
                    if (response.status !== respStatus["SUCCESS"]) {
                        showMessage(response);
                        return;
                    }
                    dispatch(setCurrentStep(-1));
                    dispatch(setClickCount(1));
                    dispatch(setCommonConfig({ key: 'coachMarkStatus', value: 1}))
                })
                .catch((error) => {
                    console.error("Error updating CoachMark status:", error);
                });
        } else {
            dispatch(setCurrentStep(-1));
            dispatch(setClickCount(1));
        }
    };

    // If `currentStep` is -1, do not render the CoachMarkPopup
    if (currentStep === -1) {
        return null;
    }

    return (
        <>
            {
                currentStep === 1 ? (
                    <div className="popup-container">
                        <div className="quick-tip">
                           {/* <TbBulb /><span>Quick tip {clickStep}/{device == 'Mobile' ? 10 : 13}</span>  */}
                          {/* <TbBulb /><span>{`Quick tip ${clickStep}/${device == 'Mobile' ? 10 :  (depositUrl ? 14 : 13)}`}</span> */}
                        <TbBulb /><span>{`Quick tip ${clickStep}/${device === 'Mobile' ? (depositUrl ? 11 : 10) : (depositUrl ? 14 : 13)}`}</span>
                        </div>
                        <div className="popup-content">
                            <div className='text'>{selectedData[currentStep].header}</div>
                            <p className="market-bet">{selectedData[currentStep].description}</p>
                            {selectedData[currentStep].headerTwo && (
                                <div className='text'>{selectedData[currentStep].headerTwo}</div>
                            )}
                            {selectedData[currentStep].descriptionTwo && (
                                <p className="market-bet">{selectedData[currentStep].descriptionTwo}</p>
                            )}
                        </div>
                        <div className='custom-action'>
                            <button onClick={handleDone} className="popup-button">
                                {selectedData.skipAll}
                            </button>
                            <button onClick={handleNext} className="popup-button">
                                {selectedData.next}

                                <div className="right-arr"><MdKeyboardArrowRight /></div>
                            </button>
                        </div>
                        <span className='custom-tooltip-top-arrow'></span>
                        <span className='custom-tooltip-arrow'></span>
                    </div>
                ) : (
                    <div className="custom-tooltip"
                        onClick={(e) => e.stopPropagation()} // Prevent event bubbling
                    >
                        {
                            ((marketCloseStatus != 0 && (allowed_games !== null && allowed_games?.allowed_game_id.split(',').includes(String(gameId)))) || (marketCloseStatus != 0 && allowed_games == null)) &&
                            <>
                                <div className="quick-tip">
                                {/* <TbBulb /><span>{`Quick tip ${clickStep}/${device == 'Mobile' ? 10 :  (depositUrl ? 14 : 13)}`}</span> */}
                                <TbBulb /><span>{`Quick tip ${clickStep}/${device === 'Mobile' ? (depositUrl ? 11 : 10) : (depositUrl ? 14 : 13)}`}</span>
                                </div>
                                <div className="text">{selectedData[currentStep].header}</div>
                                <p className="market-bet">{selectedData[currentStep].description}</p>
                                {selectedData[currentStep].headerTwo && (
                                    <div className='text setting'>{selectedData[currentStep].headerTwo}</div>
                                )}
                                {selectedData[currentStep].descriptionTwo && (
                                    <p className="market-bet setting">{selectedData[currentStep].descriptionTwo}</p>
                                )}
                                <div className="custom-action">
                                    {currentStep < valueDone ? (
                                        <>
                                            <div className="custom-bet" onClick={handleDone}>
                                                {selectedData.skipAll}
                                            </div>
                                            <div className="custom-bet" onClick={handleNext}>
                                                {selectedData.next}
                                                <div className="right-arr"><MdKeyboardArrowRight /></div>
                                            </div>
                                        </>
                                    ) : (
                                        <div className="custom-bet" onClick={handleDone}>
                                            {selectedData.done}
                                        </div>
                                    )}
                                </div>
                                <span className="custom-tooltip-arrow"></span>
                            </>
                        }

                        {
                            ((currentStep < valueDone && marketCloseStatus == 0) || (allowed_games !== null && !allowed_games?.allowed_game_id.split(',').includes(String(gameId)))
                            ) &&

                            <>
                                {/* <div className="quick-tip">
                                </div> */}
                                <div className="text"></div>
                                <p className="market-bet">{selectedData[currentStep].closeMarketRowOne}</p>
                                <p className="market-bet">{selectedData[currentStep].closeMarketRowTwo}</p>
                                <div className="custom-action">
                                    <div className="custom-bet" ></div>

                                    <div className="custom-bet" onClick={handleCloseMarket}>
                                        {selectedData.close}
                                    </div>


                                </div>
                                <span className="custom-tooltip-arrow"></span>
                            </>
                        }

                    </div>
                )
            }
        </>
    )
}

export default CoachMarkPopup